import { ClientAnalytics, loadScript } from "@shopify/hydrogen";
import { useEffect } from "react";

const URL = `https://www.googletagmanager.com/gtag/js?id=${
  import.meta.env.VITE_GTAG_ID
}`;
let init = false;

export default function GoogleAnalytics() {
  useEffect(() => {
    if (!init) {
      init = true;

      // Load the gtag script
      loadScript(URL).catch(() => {});
      function trackPageView(payload) {
        gtag("event", "page_view");
      }

      // gtag initialization code
      window.dataLayer = window.dataLayer || [];
      function gtag(..._args: any) {
        window.dataLayer.push(arguments);
      }
      gtag("js", new Date());

      // Configure your gtag
      gtag("config", import.meta.env.VITE_GTAG_ID, {
        send_page_view: false,
      });

      // Listen for events from Hydrogen
      ClientAnalytics.subscribe(
        ClientAnalytics.eventNames.PAGE_VIEW,
        (payload) => {
          trackPageView(payload);
        }
      );

      ClientAnalytics.hasSentFirstPageView() &&
        trackPageView(ClientAnalytics.getPageAnalyticsData());
    }
  });

  return null;
}
